module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_background_image4.e7b0b19d.svg";